import { render, staticRenderFns } from "./idCardVerification.vue?vue&type=template&id=58e0fc20&"
import script from "./idCardVerification.vue?vue&type=script&lang=js&"
export * from "./idCardVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports